import { Component, OnInit, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { Router } from '@angular/router';
import { SettingsService } from 'src/app/core/settings/settings.service';
import { CeqTableComponent } from 'src/app/ceq/common/ceq-table/ceq-table.component';
import { EditChildRendered } from '../../../common/renders/edit-child-rendered';
import { DeleteChildRendered } from '../../../common/renders/delete-child-rendered';
import { ZipcodeService } from '../zipcode.service';
import { UserLogin } from 'src/app/ceq/common/models/UserLogin.Model';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-zipcode-list',
  templateUrl: './zipcode-list.component.html',
  styleUrls: ['./zipcode-list.component.scss']
})
export class ZipcodeListComponent implements OnInit {

  @ViewChild('CeqGrid', { static: false }) ceqGrid: CeqTableComponent;
  
  options: GridOptions;
  PageSizes = [10, 25, 50, 100, 1000];
  pageSize = 10;
  fileToUpload: File | null = null;
  saving: boolean = false;
  userLogin: UserLogin;
  neigbhoodCode: string = '';
  stateCode: string = '';

  gridOptions = {
    context: this,
    frameworkComponents: {
      childEditRenderer: EditChildRendered,
      childDeleteMessageRenderer: DeleteChildRendered
    },
    suppressHorizontalScroll: true,
    onRowDoubleClicked: (params: any) => this.edit(params),
    icons: {
      sortAscending: '<i class="fa fa-sort-up" style="margin-left:10px"></i>',
      sortDescending: '<i class="fa fa-sort-down" style="margin-left:10px"></i>',
      sortUnSort: '<i class="fa fa-sort" style="margin-left:10px"></i>'
    }
  };

  columnDefs = [
    { headerName: 'Código postal', field: 'IdZipCode', width: 10, sortable: true, resizable: true },
    { 
      headerName: 'Colonia', 
      field: 'NeighborhoodCode', 
      width: 25, 
      cellRenderer: (p: any) => `${p.data.NeighborhoodCode} - ${p.data.NeighborhoodName}` 
    },
    { 
      headerName: 'Ciudad', 
      field: 'CityCode', 
      width: 25, 
      cellRenderer: (p: any) => `${p.data.CityCode} - ${p.data.CityDescription}` 
    },
    { 
      headerName: 'Estado', 
      field: 'StateCode', 
      width: 20, 
      cellRenderer: (p: any) => `${p.data.StateCode} - ${p.data.StateDescription}` 
    },
    { 
      headerName: 'Localidad', 
      field: 'LocationCode', 
      width: 20, 
      cellRenderer: (p: any) => `${p.data.LocationCode} - ${p.data.LocationDescription}` 
    }
  ];

  constructor(
    private router: Router,
    private settings: SettingsService,
    private globalFunctionService: GlobalFunctionsService,
    private zipcodeService: ZipcodeService
  ) { }

  ngOnInit(): void {
    this.userLogin = this.settings.getUser();
  }

  gridEmiter(GridOptions: GridOptions) {
    this.options = GridOptions;
    this.getFiscalConfig();
  }

  async refresh(){
    this.getFiscalConfig();
  }

  onPageSizeChange(value: any) {
    this.pageSize = Number(value); // Aseguramos el tipo numérico
    this.getFiscalConfig();
  }

  getFiscalConfig() {
    let url = `zipcode/${this.userLogin.Org}/list/${this.pageSize}`;
    const params = [];

    if (this.stateCode) params.push(`stateCode=${this.stateCode}`);
    if (this.neigbhoodCode) params.push(`neighborhoodCode=${this.neigbhoodCode}`);

    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    this.ceqGrid.endPoint = url;
    this.ceqGrid.refreshTable();
  }

  // Ajustado para recibir el File directamente desde aph-custom-load-file
  async handleFileInput(file: File) {
    this.fileToUpload = file;

    if (this.fileToUpload) {
      if (this.fileToUpload.name.toLowerCase().endsWith(".csv")) {
        this.uploadFileToActivity();
      } else {
        await this.globalFunctionService.messageBimbo('El archivo seleccionado debe tener formato .csv', 'warning', '¡Cuidado!');
        this.fileToUpload = null;
      }
    }
  }

  async uploadFileToActivity() {
    if (!this.fileToUpload) return;

    const formData: FormData = new FormData();
    formData.append('zipCodes', this.fileToUpload, this.fileToUpload.name);
    
    this.saving = true;
    
    // Mostramos el loading de Bimbo
    await this.globalFunctionService.messageBimbo('Por favor espere...', 'loading', 'Validando información...');

    this.zipcodeService.importZipCodes(formData).subscribe({
      next: async () => {
        Swal.close(); // Cerramos el loading
        await this.globalFunctionService.messageBimbo('Información importada correctamente', 'success', '¡Éxito!');
        this.fileToUpload = null;
        this.getFiscalConfig(); // Refrescar tabla automáticamente
      },
      error: async (err) => {
        Swal.close(); // Cerramos el loading incluso en error
        const msg = err.error?.message || 'Error al procesar el archivo';
        await this.globalFunctionService.messageBimbo(msg, 'error', '¡Error!');
        this.fileToUpload = null;
      },
      complete: () => {
        this.saving = false;
      }
    });
  }
  edit(row: any) {
    this.router.navigate(['/tax/zipcode', row.data.IdZipCode]);
  }
}